import {BuyingFormType} from '../types/BuyingFormType';
import {moneyToString} from './moneyToString';

export const transformBuyingFormToMinisale = (buyingForm: BuyingFormType) => ({
  minisaleId: buyingForm.id,
  customerBuyingStatement: buyingForm.customerBuyingStatement ?? false,
  interestRate: buyingForm.interestRate,
  isVatDeductible: buyingForm.isVatDeductible?.[0] === 'true',
  vehicleData: {
    ...buyingForm.vehicleData,
    type: buyingForm.vehicleData?.type?.[0] ?? null,
    fuelType: buyingForm.vehicleData?.fuelType?.[0] ?? null,
    secondaryFuelType: buyingForm.vehicleData?.secondaryFuelType?.[0] ?? null,
    transmission: buyingForm.vehicleData?.transmission?.[0] ?? null,
    bodyStyle: buyingForm.vehicleData?.bodyStyle?.[0] ?? null,
    drive: buyingForm.vehicleData?.drive?.[0] ?? null,
  },
  vatType: buyingForm.vatType,
  vatDirection: buyingForm.vatDirection,
  priceOfferedWithoutVat: moneyToString(buyingForm.priceOfferedWithoutVat),
  priceOfferedWithVat: moneyToString(buyingForm.priceOfferedWithVat),
  priceOfferedBase: moneyToString(buyingForm.priceOfferedWithoutVat),
});
